<template>
  <RootModalComponent
    :name="$MODAL_NAME.CHANGE_STATUS"
    :title="'d_ws_change_status' | translate"
    width="400"
    :mobile-type="$MODAL_TYPE_MOBILE.BUBBLE"
    :frame="true"
  >
    <div class="status-modal">
      <div class="status-modal__inner">
        <ul>
          <li :class="{'is--active': status.id === $store.currentStatus}" v-for="status in statuses" :key="status.id" @click="changeStatus(status.id)">
            <i :class="status.icon"></i>
            <span class="text" :title="(status.hasOwnProperty('default') && status.default) ? $options.filters.translate(status.title) : status.title">
              {{ (status.hasOwnProperty('default') && status.default) ? $options.filters.translate(status.title) : status.title }}
            </span>
            <span class="timer" v-if="status.id === $store.currentStatus">
              <Timer :ticket-time="$store.currentStatusTimestamp" />
            </span>
          </li>
        </ul>
      </div>
    </div>
  </RootModalComponent>
</template>

<script>
import RootModalComponent from './RootModalComponent'
import Timer from "../controls/Timer";

export default {
  components: {
    RootModalComponent,
    Timer
  },
  computed: {
    statuses() {
      return this.$store.statuses;
    }
  },
  methods: {
    changeStatus(id) {
      if (this.$store.statusTransactionEnd) {
        this.$store.statusTransactionEnd = false;
        this.$statusService.changeStatus(id).then(() => {
          this.$modal.hide(this.$MODAL_NAME.CHANGE_STATUS);
          this.$store.statusTransactionEnd = true;
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .status-modal {
    &__inner {
      padding: 24px 34px 40px 34px;
      ul {
        margin: 0;
        padding: 0;
        list-style: none;
        li {
          font-size: 16px;
          font-weight: 500;
          line-height: 48px;
          font-feature-settings: 'zero' on;
          display: flex;
          align-items: center;
          color: var(--label-secondary);
          cursor: pointer;
          padding: 0 8px 0 16px;
          border-radius: 6px;
          &:hover {
            background: var(--light-02);
          }
          i {
            font-weight: normal;
            font-size: 24px;
            margin-right: 16px;
          }
          &.is--active {
            color: var(--label-primary);
          }
          span.timer {
            margin-left: auto;
            font-size: 12px;
            font-weight: normal;
            color: var(--label-secondary);
          }
          span.text {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
          }
        }
      }
    }
  }

  @media (max-width: 425px) {
    .status-modal {
      &__inner {
        padding: 0;
        ul {
          li {
            padding-right: 16px;
            &.is--active {
              background: transparent;
            }
          }
        }
      }
    }
  }
</style>
